import { render, staticRenderFns } from "./ListagemGdigital.vue?vue&type=template&id=591b0ab8&scoped=true"
import script from "./ListagemGdigital.vue?vue&type=script&lang=js"
export * from "./ListagemGdigital.vue?vue&type=script&lang=js"
import style0 from "./ListagemGdigital.vue?vue&type=style&index=0&id=591b0ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591b0ab8",
  null
  
)

export default component.exports